import React, { useEffect } from 'react';

export default function RedirectToLA(props) {

	useEffect(() => {
		// const PTE_LA = process.env.REACT_APP_LA_URL;
        const VITE_LA_URL = import.meta.env.VITE_LA_URL;
		window.location.href = `${VITE_LA_URL}/auth/login`;
	}, []);

	return "";
}